import "./ProyectosCommon.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { NucleoResponse } from "../../../shared/response/proyectos/NucleoResponse";
import { CultivoResponse } from "../../../shared/response/proyectos/CultivoResponse";
import { TecnicoResponse } from "../../../shared/response/proyectos/TecnicoResponse";
import { MacroProyectoResponse } from "../../../shared/response/proyectos/MacroProyectoResponse";
import { NucleoService } from "../../services/proyectos/NucleoService";
import { NucleoDeleteService } from "../../services/proyectos/NucleoDeleteService";
import { CultivoService } from "../../services/proyectos/CultivoService";
import { TecnicoService } from "../../services/proyectos/TecnicoService";
import { MacroProyectoService } from "../../services/proyectos/MacroProyectoService";
import { NucleoFormModal } from "./NucleoFormModal";
import { ConfirmDialogComponent } from "../../../shared/components/ConfirmDialogComponent";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";
import { fmtCentavos } from "../../../shared/utils/proyectosFormat";

export class NucleosPage extends BasePageComponent {
  private _all: NucleoResponse[] = [];
  private _filtered: NucleoResponse[] = [];
  private _cultivos: CultivoResponse[] = [];
  private _tecnicos: TecnicoResponse[] = [];
  private _macros: MacroProyectoResponse[] = [];
  private _tbody!:  HTMLTableSectionElement;
  private _totEl!:  HTMLSpanElement;
  private _search!: HTMLInputElement;

  public getAppRoute(): string { return "/proyectos/nucleos"; }
  public getPageTitle(): string | null { return "Proyectos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page pr-page";
    pageContent.innerHTML = `
      <div class="pr-content">
        <div class="pr-pg-hd">
          <div>
            <div class="pr-pg-ey">Proyectos · Configuración</div>
            <div class="pr-pg-ti">Núcleos</div>
            <div class="pr-pg-su">Agrupaciones asociativas de beneficiarios cercanos entre sí</div>
          </div>
          <button class="sx-btn sx-btn-primary sx-btn-sm" id="nuc-nuevo"><i class="ph ph-plus"></i> Nuevo núcleo</button>
        </div>

        <div class="pr-frow">
          <div class="pr-sw">
            <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
            <input class="pr-si" id="nuc-search" placeholder="Buscar nombre o región…">
          </div>
          <span class="pr-ftot" id="nuc-tot"></span>
        </div>

        <div class="pr-tbl-wrap">
          <table class="pr-tbl">
            <thead>
              <tr><th>Núcleo</th><th>Región</th><th>Cultivo</th><th>Técnico</th><th>Macro-Proyecto</th><th>Proyectos</th><th>Límites</th><th>Acciones</th></tr>
            </thead>
            <tbody id="nuc-tbody"><tr><td colspan="8" class="pr-empty">Cargando…</td></tr></tbody>
          </table>
        </div>
      </div>
    `;

    this._tbody  = document.getElementById("nuc-tbody")! as HTMLTableSectionElement;
    this._totEl  = document.getElementById("nuc-tot")!;
    this._search = document.getElementById("nuc-search")! as HTMLInputElement;
    this._search.oninput = () => this._filterAndRender();
    document.getElementById("nuc-nuevo")!.onclick = () => this._onCreate();

    void this._loadData();
  }

  protected override beforeDispose(): void {}

  private async _loadData(): Promise<void> {
    try {
      const [items, cultivos, tecnicos, macros] = await Promise.all([
        NucleoService.instance.get(),
        CultivoService.instance.get().catch(() => [] as CultivoResponse[]),
        TecnicoService.instance.get().catch(() => [] as TecnicoResponse[]),
        MacroProyectoService.instance.get().catch(() => [] as MacroProyectoResponse[]),
      ]);
      this._all = items.filter((n) => !n.isEliminado).sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._cultivos = cultivos.filter((c) => !c.isEliminado).sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._tecnicos = tecnicos.filter((t) => !t.isEliminado && t.isActivo).sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._macros = macros.filter((m) => !m.isEliminado).sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._filterAndRender();
    } catch (error) {
      errorMessageComponent.addError("Error al cargar núcleos", (error as Error).message);
      this._tbody.innerHTML = `<tr><td colspan="8" class="pr-empty">Error al cargar</td></tr>`;
    }
  }

  private _filterAndRender(): void {
    const q = this._search.value.toLowerCase().trim();
    this._filtered = this._all.filter((n) =>
      !q || n.nombre.toLowerCase().includes(q) || n.region.toLowerCase().includes(q),
    );
    this._render();
  }

  private _render(): void {
    const list = this._filtered;
    this._totEl.textContent = `${list.length} núcleo${list.length === 1 ? "" : "s"}`;
    if (list.length === 0) {
      this._tbody.innerHTML = `<tr><td colspan="8" class="pr-empty">Sin resultados</td></tr>`;
      return;
    }
    this._tbody.innerHTML = list.map((n, i) => `
      <tr>
        <td style="font-weight:var(--sx-weight-semibold)">${this._esc(n.nombre)}</td>
        <td>${this._esc(n.region)}</td>
        <td>${n.cultivoNombre ? this._esc(n.cultivoNombre) : `<span style="color:var(--sx-text-tertiary)">—</span>`}</td>
        <td>${n.tecnicoNombre ? this._esc(n.tecnicoNombre) : `<span style="color:var(--sx-text-tertiary)">—</span>`}</td>
        <td>${n.macroProyectoNombre ? this._esc(n.macroProyectoNombre) : `<span style="color:var(--sx-text-tertiary)">—</span>`}</td>
        <td class="pr-num">${n.totalProyectos}</td>
        <td style="font-size:var(--sx-text-xs);color:var(--sx-text-tertiary)">
          ${n.haMaxAsociacion != null ? `Máx ${n.haMaxAsociacion} ha` : "—"}${n.montoMaxReferencial != null ? ` · ${fmtCentavos(n.montoMaxReferencial)}` : ""}
        </td>
        <td>
          <div class="pr-actions">
            <button class="sx-btn sx-btn-secondary sx-btn-sm" data-act="editar" data-idx="${i}">Editar</button>
            <button class="sx-btn sx-btn-ghost sx-btn-icon sx-btn-sm" data-act="eliminar" data-idx="${i}" title="Eliminar"><i class="ph ph-trash"></i></button>
          </div>
        </td>
      </tr>`).join("");

    this._tbody.querySelectorAll<HTMLButtonElement>("button[data-act]").forEach((btn) => {
      const n = list[Number(btn.dataset.idx)];
      btn.onclick = () => {
        if (btn.dataset.act === "editar")   this._onEdit(n);
        if (btn.dataset.act === "eliminar") this._onDelete(n);
      };
    });
  }

  private _onCreate(): void {
    new NucleoFormModal(this._cultivos, this._tecnicos, this._macros, (saved) => {
      this._all = [saved, ...this._all].sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._filterAndRender();
    }).init();
  }

  private _onEdit(n: NucleoResponse): void {
    new NucleoFormModal(this._cultivos, this._tecnicos, this._macros, (saved) => {
      this._all = this._all.map((x) => (x.id === saved.id ? saved : x));
      this._filterAndRender();
    }, n).init();
  }

  private _onDelete(n: NucleoResponse): void {
    new ConfirmDialogComponent({
      title: "Eliminar núcleo",
      message: `¿Eliminar "${n.nombre}"?${n.totalProyectos > 0 ? ` Tiene ${n.totalProyectos} proyecto(s) asociado(s).` : ""}`,
      confirmLabel: "Eliminar",
      onConfirm: async () => {
        try {
          await new NucleoDeleteService().delete(n.id);
          this._all = this._all.filter((x) => x.id !== n.id);
          this._filterAndRender();
        } catch (error) {
          errorMessageComponent.addError("Error al eliminar", (error as Error).message);
        }
      },
    }).init();
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
